module.exports = __webpack_public_path__ + "img/gadung.4f296ed1.svg";